import React from 'react';
import { Icon, Typography } from "../../index";
import './pill.scss'

export const PillButton = ({
    disabled = false,
    icon,
    label,
    onClick = () => { },
    open,
    selected = false,
    showArrow = false,
    ...inputProps
}) => {

    const pillBtnClasses = [
        `bsw-pill__button`,
        `${selected ? 'bsw-pill__button--selected' : ''}`,
        `${disabled ? 'bsw-pill__button--disabled' : ''}`
    ].join(' ');

    return (
        <button
            {...inputProps}
            type="button"
            className={pillBtnClasses}
            onClick={onClick}
            disabled={disabled}
        >
            {icon &&
                <Icon name={icon} color={selected ? '$color-primary-a2' : '$color-secondary-a2' } />
            }
            <Typography type="body-01" color={selected ? '$color-primary-a2' : '$color-secondary-a2' }>{label}</Typography>
            {showArrow &&
                <Icon name={open ? "chevron-up" : "chevron-down"} color="$color-primary-a2" size="small" />
            }
        </button>
    )
}
